import { createSelector } from 'reselect';

export default function getSelectors(reduxActionName: string): any {
  const selectState = (state: any) => state[reduxActionName] || { isUndefined: true, reduxActionName };
  const makeSelectStateFactory = (stateName: string) => () =>
    createSelector(
      // redux scope 선택
      selectState,
      // 선택된 구역의 object key 선택
      (state) => state[stateName],
    );

  return {
    // Query 관련
    makeSelectParamsForRequest: makeSelectStateFactory('paramsForRequest'),

    // request 관련
    makeSelectData: makeSelectStateFactory('data'),
    makeSelectRequestLoading: makeSelectStateFactory('requestLoading'),
    makeSelectRequestSuccess: makeSelectStateFactory('requestSuccess'),
    makeSelectRequestError: makeSelectStateFactory('requestError'),
    makeSelectRequestErrorMessage: makeSelectStateFactory('requestErrorMessage'),
    makeSelectRequestErrorData: makeSelectStateFactory('requestErrorData'),
  };
}
